export interface IMemberMergeRequest {
    BaseMemberID: number;
    MergeMemberID: number;

    FirstName: string;
    LastName: string;
    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;

    CompanyName: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Email: string;

    PasswordMemberID: string;
    MergeInvoices: boolean;
    MergeTrainingHistory: boolean;

}

export class MemberMergeRequest implements IMemberMergeRequest {

    BaseMemberID: number;
    MergeMemberID: number;

    FirstName: string;
    LastName: string;
    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;

    CompanyName: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Email: string;

    PasswordMemberID: string;
    MergeInvoices: boolean;
    MergeTrainingHistory: boolean;
}
